import { getSafeAreaPaddings } from "@clipboard-health/ui-theme";
import { Stack } from "@mui/material";
import OpenChannel from "@sendbird/uikit-react/OpenChannel";
import { type RenderUserProfileProps } from "@sendbird/uikit-react/types/types";
import { useHistory, useParams } from "react-router-dom";

import { IconButton } from "../redesign/components/IconButton";
import { PageWrapper } from "../redesign/components/PageWrapper";
import { CHATROOMS_FULL_PATH } from "./paths";
import { UserProfile } from "./UserProfile";

export function ChatroomDetailPage(): JSX.Element {
  const history = useHistory();
  const { chatroomId } = useParams<{ chatroomId: string }>();

  const renderUserProfile = (props: RenderUserProfileProps): JSX.Element => {
    return <UserProfile profileProps={props} />;
  };

  return (
    <PageWrapper
      sx={{
        ...getSafeAreaPaddings({
          top: true,
        }),
      }}
    >
      <Stack direction="column" spacing={2} sx={{ paddingLeft: 5 }}>
        <IconButton
          size="small"
          variant="outlined"
          iconType="chevron-left"
          onClick={() => {
            history.replace(CHATROOMS_FULL_PATH);
          }}
        />
      </Stack>
      <OpenChannel
        channelUrl={chatroomId}
        disableUserProfile={false}
        renderUserProfile={renderUserProfile}
      />
    </PageWrapper>
  );
}
